import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import NhanVayApi from "service/nhanVayApi";
import { pushNotification } from "utils/notifications";
import { getListNhanVay, updateDataSearch } from "../../../../actions/NhanVay/";
export const ModalXoa = (props) => {
  const thongbaoerror = {
    Message: "",
    Error: 0,
  };
  const [isAllowDelete, setIsAllowDelete] = useState(thongbaoerror);

  //Mở popup chỉ gọi API kiểm tra (cùng điều kiện với xóa); API xoa-nhan-vay xóa thật nên chỉ gọi khi bấm Xác nhận
  const kiemTraXoa = () => {
    NhanVayApi.kiemtraSuaNhanVay(props.nhanvayId).then((response) => {
      if (!response.data) return;
      setIsAllowDelete({
        ...isAllowDelete,
        Message: response.data.Message,
        Error: response.data.Error,
      });
    });
  };

  useEffect(() => {
    kiemTraXoa();
  }, []);

  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);
  //Ref chặn bấm Xác nhận 2 lần liên tiếp trước khi state kịp render lại
  const isSavingRef = React.useRef(false);
  const [isSaving, setIsSaving] = useState(false);
  const onSubmit = () => {
    if (isSavingRef.current) return;
    isSavingRef.current = true;
    setIsSaving(true);
    NhanVayApi.xoaNhanVay(props.nhanvayId)
      .then((response) => {
        //Mất mạng/timeout: apisauce trả data null, server có thể đã xóa nên nhắc kiểm tra trước khi thử lại
        if (!response.data) {
          pushNotification(
            "Không nhận được phản hồi từ máy chủ, vui lòng kiểm tra lại danh sách hợp đồng trước khi thử lại!",
            "error",
            "TOP_CENTER",
            5000
          );
          return;
        }
        if (response.data.Error === 1) {
          pushNotification(
            String(response.data.Message || "").replace(/<br\s*\/?>/gi, " "),
            "error",
            "TOP_CENTER",
            3000
          );
          return;
        }
        pushNotification("Bạn đã xoá thành công", "success", "TOP_CENTER", 1000);
        props.onHide();
        dispatch(getListNhanVay(dataSearch));
      })
      .finally(() => {
        isSavingRef.current = false;
        setIsSaving(false);
      });
  };
  return (
    <Modal
      {...props}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-delete"></i>
          </span>
          Xác nhận xoá
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              {isAllowDelete.Error === 1 ? (
                <div>
                  Hợp đồng{" "}
                  <span class="home-new-blue">{props.item.MaNhanVay}</span>
                  &nbsp;của khách hàng{" "}
                  <span class="home-new-blue">{props.item.TenChuNo}</span> đã
                  sinh ra phiếu thu. Nên bạn không thể thực hiện việc xóa.&nbsp;
                  <br />
                  Muốn xóa bạn phải đi đến phiếu thu đó tại: Quản lý thu chi
                  -&gt; Thu/Chi hợp đồng
                </div>
              ) : (
                <div className="form-group row">
                  <label
                    className="col-md-12 label-control text-left"
                    for="projectinput2"
                  >
                    Bạn có chắc chắn muốn xóa không?
                  </label>
                </div>
              )}
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        {isAllowDelete.Error === 1 ? (
          ""
        ) : (
          <button
            type="button"
            className="btn btn-new-main btn-checknew"
            onClick={onSubmit}
            disabled={isSaving}
          >
            {isSaving ? (
              <>
                <span className="spinner-border spinner-border-sm"></span>
                &nbsp; Đang xử lý...
              </>
            ) : (
              <>
                <span className="btn-icon-left">
                  <i className="mdi mdi-check"></i>
                </span>
                Xác nhận
              </>
            )}
          </button>
        )}

        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
